import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { onSnapshot, collection, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { setFirestoreData } from "./slices/firestoreSlice";

export const useFirestoreConnect = (queries) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubs = queries.map((q) => {
      let firestoreQuery;
      if (typeof q === "string") {
        firestoreQuery = collection(db, q);
      } else {
        const { collection: colName, where: whereClauses } = q;
        let baseQuery = collection(db, colName);
        if (whereClauses) {
          const clauses = Array.isArray(whereClauses[0])
            ? whereClauses.map((c) => where(...c))
            : [where(...whereClauses)];
          firestoreQuery = query(baseQuery, ...clauses);
        } else {
          firestoreQuery = baseQuery;
        }
      }

      return onSnapshot(firestoreQuery, (snapshot) => {
        const data = {};
        const ordered = [];
        snapshot.forEach((doc) => {
          const docData = { id: doc.id, ...doc.data() };
          data[doc.id] = docData;
          ordered.push(docData);
        });

        dispatch(
          setFirestoreData({
            collection: typeof q === "string" ? q : q.collection,
            storeAs: typeof q === "object" ? q.storeAs : undefined,
            data,
            ordered,
          })
        );

      });
    });

    return () => {
      unsubs.forEach((unsub) => unsub());
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(queries), dispatch]);
};

export const isLoaded = (state) => {
  return state && state.isLoaded;
};

export const isEmpty = (state) => {
  return !state || state.isEmpty;
};
